import { useTranslation } from 'react-i18next';
import useRedirectLogin from '../../_common/hooks/useRedirectLogin';
import useMixpanelEvent from '../../_common/hooks/useMixpanelEvent';
import { ButtonGroup } from '@carrot/style-components/button-group';
import { Button } from '@carrot/style-components/button';
import { track } from '../../utils/mixpanel';
import { Navbar } from './navbar';

/**
 * @package
 */
export const UnauthNavbar = () => {
  const { t } = useTranslation();
  const { get: getRedirectLogin } = useRedirectLogin();
  const trackNavBarSignupCTA = useMixpanelEvent();
  return (
    <Navbar
      showLogo
      showActionsOnMobile
      actions={
        <ButtonGroup.NoWrap>
          <Button
            as="link"
            styles={{
              size: 'regular',
              variant: 'primary'
            }}
            to={`/letsgo?redirectLogin=${getRedirectLogin()}`}
            onClick={() => {
              track(trackNavBarSignupCTA);
            }}
          >
            {t('common:header.signUpToTrade')}
          </Button>
          <Button
            as="link"
            styles={{
              size: 'small',
              variant: 'borderless'
            }}
            to={`/login?redirectLogin=${getRedirectLogin()}`}
          >
            {t('common:header.login')}
          </Button>
        </ButtonGroup.NoWrap>
      }
    />
  );
};
